import { createFileRoute } from "@tanstack/react-router";
import { TestForm } from "@/components/admin/tests/TestForm";

export const Route = createFileRoute("/dashboard/admin/tests/$testId")({
  component: AdminEditTestPage,
});

function AdminEditTestPage() {
  const { testId } = Route.useParams();
  return <TestForm testId={testId} />;
}
